/* global integrationConfigured, syncEnabled, action, toggleUrl, model, syncNowUrl */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ToggleSync from './ToggleSync';

export default function ToggleGlCodesSync(props) {
    return (
        <ToggleSync
            integrationConfigured={props.integrationConfigured}
            syncEnabled={props.syncEnabled}
            action={props.action}
            toggleUrl={props.toggleUrl}
            model={props.model}
            modelName={$t('GL codes')}
            syncNowUrl={props.syncNowUrl}
            toggleCallback={() => {
                window.location.reload();
            }}
            toggleModalId={'enable-gl-codes-sync'}
        />
    );
}

if (document.getElementById('toggleGlCodesSyncButton')) {
    const rootEl = document.getElementById('toggleGlCodesSyncButton');
    ReactDOM.render(
        <App>
            <ToggleGlCodesSync
                integrationConfigured={integrationConfigured}
                syncEnabled={syncEnabled}
                action={action}
                toggleUrl={toggleUrl}
                model={model}
                syncNowUrl={syncNowUrl}
            />
        </App>,
        rootEl,
    );
}
